export const ROLE = [
  {
    Lv: '1',
    HP: '28',
    MP: '0',
    POW: '5',
    SPD: '4',
    DEF: '2',
    EX: '0',
    NEXT: '12'
  },
  {
    Lv: '2',
    HP: '37',
    MP: '0',
    POW: '7',
    SPD: '5',
    DEF: '3',
    EX: '12',
    NEXT: '20'
  },
  {
    Lv: '3',
    HP: '40',
    MP: '0',
    POW: '12',
    SPD: '7',
    DEF: '4',
    EX: '32',
    NEXT: '40'
  },
  {
    Lv: '4',
    HP: '48',
    MP: '0',
    POW: '17',
    SPD: '7',
    DEF: '4',
    EX: '72',
    NEXT: '68'
  },
  {
    Lv: '5',
    HP: '52',
    MP: '0',
    POW: '18',
    SPD: '12',
    DEF: '6',
    EX: '140',
    NEXT: '140'
  },
  {
    Lv: '6',
    HP: '55',
    MP: '0',
    POW: '20',
    SPD: '18',
    DEF: '9',
    EX: '280',
    NEXT: '280'
  },
  {
    Lv: '7',
    HP: '56',
    MP: '0',
    POW: '29',
    SPD: '21',
    DEF: '10',
    EX: '560',
    NEXT: '440'
  },
  {
    Lv: '8',
    HP: '58',
    MP: '0',
    POW: '30',
    SPD: '24',
    DEF: '11',
    EX: '1000',
    NEXT: '800'
  },
  {
    Lv: '9',
    HP: '58',
    MP: '0',
    POW: '33',
    SPD: '24',
    DEF: '11',
    EX: '1800',
    NEXT: '1000'
  },
  {
    Lv: '10',
    HP: '60',
    MP: '0',
    POW: '36',
    SPD: '28',
    DEF: '13',
    EX: '2800',
    NEXT: '1100'
  },
  {
    Lv: '11',
    HP: '62',
    MP: '0',
    POW: '41',
    SPD: '30',
    DEF: '15',
    EX: '3900',
    NEXT: '1400'
  },
  {
    Lv: '12',
    HP: '63',
    MP: '0',
    POW: '44',
    SPD: '33',
    DEF: '16',
    EX: '5300',
    NEXT: '2300'
  },
  {
    Lv: '13',
    HP: '64',
    MP: '0',
    POW: '49',
    SPD: '37',
    DEF: '18',
    EX: '7600',
    NEXT: '2400'
  },
  {
    Lv: '14',
    HP: '65',
    MP: '0',
    POW: '53',
    SPD: '37',
    DEF: '18',
    EX: '10000',
    NEXT: '3000'
  },
  {
    Lv: '15',
    HP: '68',
    MP: '0',
    POW: '55',
    SPD: '41',
    DEF: '20',
    EX: '13000',
    NEXT: '4000'
  },
  {
    Lv: '16',
    HP: '70',
    MP: '0',
    POW: '58',
    SPD: '47',
    DEF: '23',
    EX: '17000',
    NEXT: '4000'
  },
  {
    Lv: '17',
    HP: '75',
    MP: '0',
    POW: '61',
    SPD: '49',
    DEF: '24',
    EX: '21000',
    NEXT: '5000'
  },
  {
    Lv: '18',
    HP: '78',
    MP: '0',
    POW: '66',
    SPD: '49',
    DEF: '24',
    EX: '26000',
    NEXT: '6000'
  },
  {
    Lv: '19',
    HP: '82',
    MP: '0',
    POW: '69',
    SPD: '52',
    DEF: '25',
    EX: '32000',
    NEXT: '8000'
  },
  {
    Lv: '20',
    HP: '95',
    MP: '0',
    POW: '75',
    SPD: '56',
    DEF: '27',
    EX: '40000',
    NEXT: '10000'
  },
  {
    Lv: '21',
    HP: '101',
    MP: '0',
    POW: '81',
    SPD: '59',
    DEF: '28',
    EX: '50000',
    NEXT: '12000'
  },
  {
    Lv: '22',
    HP: '110',
    MP: '0',
    POW: '87',
    SPD: '65',
    DEF: '31',
    EX: '62000',
    NEXT: '13000'
  },
  {
    Lv: '23',
    HP: '119',
    MP: '0',
    POW: '91',
    SPD: '66',
    DEF: '31',
    EX: '75000',
    NEXT: '15000'
  },
  {
    Lv: '24',
    HP: '125',
    MP: '0',
    POW: '94',
    SPD: '70',
    DEF: '33',
    EX: '90000',
    NEXT: '17000'
  },
  {
    Lv: '25',
    HP: '134',
    MP: '0',
    POW: '99',
    SPD: '70',
    DEF: '33',
    EX: '107000',
    NEXT: '20000'
  },
  {
    Lv: '26',
    HP: '142',
    MP: '0',
    POW: '103',
    SPD: '73',
    DEF: '34',
    EX: '127000',
    NEXT: '23000'
  },
  {
    Lv: '27',
    HP: '151',
    MP: '0',
    POW: '107',
    SPD: '79',
    DEF: '37',
    EX: '150000',
    NEXT: '25000'
  },
  {
    Lv: '28',
    HP: '161',
    MP: '0',
    POW: '112',
    SPD: '82',
    DEF: '38',
    EX: '175000',
    NEXT: '25000'
  },
  {
    Lv: '29',
    HP: '168',
    MP: '0',
    POW: '116',
    SPD: '86',
    DEF: '40',
    EX: '200000',
    NEXT: '30000'
  }
]
